import { autoinject, computedFrom } from 'aurelia-framework';
import { GlobalContextService } from '../global-context-service';
import { GlobalScopeSelect } from '../scope/global-scope-select';
import { SessionStorage } from "../../../utils/session-storage-service";
import { CookieService } from "../../../utils/cookie-service";
import { ReportingStateService } from "../../../features/reporting/reporting-state-service"; 

@autoinject
export class GlobalCustomerSelect {
	static customerItemName = "customer";

	@computedFrom("GlobalCustomerSelect.customerItemName")
	get itemName(): string {
		return GlobalCustomerSelect.customerItemName;
	}

	constructor(private context: GlobalContextService, private reportingStateService: ReportingStateService) {
	}

	globalCustomerChanged(customer: any) {
		const key = this.context.getKey(GlobalScopeSelect.scopeItemName);
		CookieService.expireCookie(key);
		SessionStorage.removeFromStorage(key);
		
		// Clear reporting state when customer changes
		this.reportingStateService.removeReportListState();
		this.reportingStateService.removeReportToExport();
	}
}
